// extracted by mini-css-extract-plugin
export default {"miniWrap":"Messages__miniWrap--02AjZ"};